export default "/_next/static/images/header-bg-eb2fc43b1965242254e21574d86e25df.png";